import styled from "styled-components";
import theme from "../../../../Styles/theme";

export const Container = styled.div`
  display: flex;
  align-items: center;

  flex-direction: column;
  width: 100%;
`;

export const Title = styled.h1`
  display: flex;
  align-items: flex-start;
  justify-content: center;

  color: ${theme.colors.primary};
  font-size: max(14px, 1.3vw);
  padding-top: 5vh;
`;

export const Table = styled.table`
  width: 100%;
  background-color: ${theme.colors.darkGrey};
`;

export const Tr = styled.tr`
cursor:pointer;

&:hover{
    opacity: 0.7;
}
`;

export const Th = styled.th`
  padding: 0.5vh 2vw;
  font-size: max(1.2vw, 10px);
  position: sticky;
  top: 0;
  z-index: 1;
  color: ${theme.colors.light};
  background-color: ${theme.colors.darkGrey};
`;

export const Td = styled.td`
  color: ${theme.colors.dark};
  background-color: ${theme.colors.light};

  font-size: max(1vw, 8px);
  padding: 1vh 2vw;
  white-space: nowrap;
  
`;

export const TableContainer = styled.section`
  margin: auto;
  max-width: 100%;
  margin-top: 2vh;
  display: block;

  overflow-x/*(eixo x)*/: auto; /*Agora quando necessário a rolagem da tabela é permitida(funcionamento para o mobile)*/

  margin-bottom: 10px;
  overflow-y: scroll;
  max-height: 60vh;
  &::-webkit-scrollbar {
    width: 0.6vw;
    height: 0.6vw;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.dark}; /* color of the scroll thumb */
    border-radius: 0.25rem; /* roundness of the scroll thumb */
    height: 2px;
  }
`;

export const PlusBenfeitoria = styled.button`
  color: ${theme.colors.primary};
  display: flex;
  align-items: center;
  position:absolute;
  bottom:0;
  margin-bottom:1vh;
  
`;
